module.exports = __webpack_public_path__ + "img/Neo-Tips-Pic4-300x89.23e46e49.png";